import { useEffect, useRef } from 'react';

import {
  ContentLayout,
  ErrorPageContent,
} from '@silvertours/common-landingpages-view';
import { StageLegacy, ErrorPage } from '@silvertours/front-features';
import { analytics } from '@silvertours/front-entities';

import { Body } from './body';

const ErrorContent = ({
  content: {
    statusCode,
    stage,
    textContent: { primaryHeadline },
  },
  ...commonProps
}: ContentLayout<ErrorPageContent>) => {
  const tracked = useRef(false);
  useEffect(() => {
    if (!tracked.current) {
      const label = statusCode?.toString() ?? '';
      analytics.gtm.trackErrorPageView(label);
      tracked.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Body
      variant={{ kind: 'error' }}
      title={primaryHeadline}
      bodyTop={
        <StageLegacy.Stage
          content={stage.content}
          headline={primaryHeadline}
          variant={{ kind: 'error' }}
        />
      }
      searchData={stage?.content?.search}
      statusCode={statusCode}
      content={({ containerModule }) => [
        containerModule('errorpage.contact', <ErrorPage.Contact />),
      ]}
      {...commonProps}
    />
  );
};

export { ErrorContent };
